module.exports = __webpack_public_path__ + "img/icon_benefit-skill-development.fc166388.svg";